import { render, staticRenderFns } from "./BorrowingPage_StartNow.vue?vue&type=template&id=6bec3c15&scoped=true&"
import script from "./BorrowingPage_StartNow.vue?vue&type=script&lang=js&"
export * from "./BorrowingPage_StartNow.vue?vue&type=script&lang=js&"
import style0 from "./BorrowingPage_StartNow.vue?vue&type=style&index=0&id=6bec3c15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bec3c15",
  null
  
)

export default component.exports